import React, { useState, useEffect, useContext } from 'react';
import { string, shape } from 'prop-types';
import { ExperienceContext, useStore, useConfigService } from '@thd-nucleus/experience-context';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';

import { makeApiRequest } from '../../utils/requestHelpers';
import { hasValidPipData, triggerNewRelic } from '../../utils/helpers';
import './SponsoredPipBanner.scss';
import { initImpressionWatchers } from '../../utils/initImpressionWatchers';
import useFbtSkuListener from '../../hooks/useFbtSkuListener';
import { bannerTypes } from '../../constants/constants';

import useFetch from '../../hooks/useFetch';
import { buildRevJetBanner } from '../../utils/revjet';

import { newRelicConstants } from '../../constants';

const SponsoredPipBannerComponent = (props) => {
  const [hasData, setHasData] = useState(false);
  const experienceContext = useContext(ExperienceContext);

  let { browserId, pageContext } = props;
  const validBrowserId = browserId || experienceContext?.cookie?.adobeCookie?.MCMID;

  const schema = 'pip_sponsored';
  const schemaId = `${schema}__banner_${pageContext.data.treatment}`;

  const { fbtSkus } = useFbtSkuListener(pageContext?.data?.itemId);

  const maxWidth = experienceContext.channel === 'desktop' ? '100%' : '450px';
  const { storeId, isLocalized } = useStore({
    varnish: true,
    online: true
  });
  experienceContext.useStoreId = storeId;

  const callBannerApi = useConfigService('isBannerServiceEnabled');

  const requestConfig = {
    browserId: validBrowserId,
    schema,
    schemaId,
    experienceContext,
    pageContext,
    setHasData,
    bannerType: bannerTypes.MIDDLE,
    eventBusData: { fbtSkus },
    callBannerApi
  };

  // if callBannerApi = true, this hook will run fetch data to bannerapi

  const { data, status, error } = useFetch(requestConfig); // useFetch make is

  useEffect(() => {
    const adType = newRelicConstants.PIP_BANNER;
    if (status === 200) {

      setHasData(true);
      buildRevJetBanner({ data, requestConfig, adType });
    }
    if (status) {
      triggerNewRelic(adType, `BANNER-API-${status}`);
    }
  }, [status, callBannerApi]);

  // step 1.2 if callBannerApi:  call legacy sp-api build revjet tag
  useEffect(() => {
    const isResolvedContext = experienceContext.mounted;
    if (!callBannerApi && hasValidPipData(pageContext, fbtSkus) && isResolvedContext && validBrowserId) {
      makeApiRequest({
        browserId: validBrowserId,
        schema,
        schemaId,
        experienceContext,
        pageContext,
        setHasData,
        bannerType: bannerTypes.MIDDLE,
        eventBusData: { fbtSkus }
      });
    }
  }, [fbtSkus, experienceContext.mounted, validBrowserId, callBannerApi]);

  useEffect(() => {
    initImpressionWatchers();
  }, [hasData]);

  return (hasData && (
    <div
      data-component="SponsoredPipBanner"
      className="sponsored_pip_banner_container"
      style={{ maxWidth }}
    >
      <div id={schemaId} data-testid="sponsored-pip-banner" className="sponsored_pip_banner" />
    </div>
  ));
};

const propTypes = {
  browserId: string,
  pageContext: shape({
    label: string,
    treatment: string,
    data: shape({
      itemId: Number
    })
  })
};

const defaultProps = {
  browserId: '',
  pageContext: {}
};

SponsoredPipBannerComponent.propTypes = propTypes;
SponsoredPipBannerComponent.defaultProps = defaultProps;

const HydratedSponsoredPipBanner = withHydrator({
  id: 'hydrated-sponsored-pip-banner',
  className: 'sponsored-pip-banner-hydrator',
  scrollBuffer: 100
}, SponsoredPipBannerComponent);

const DynamicSponsoredPipBanner = withDynamicComponent(HydratedSponsoredPipBanner);
const SponsoredPipBanner = withErrorBoundary(DynamicSponsoredPipBanner);

SponsoredPipBanner.propTypes = propTypes;
SponsoredPipBanner.defaultProps = defaultProps;
SponsoredPipBanner.displayName = 'SponsoredPipBanner';

export { SponsoredPipBannerComponent, SponsoredPipBanner };
